import {
  IBrand,
  IBrandRes,
  ICatalog,
  ICatalogRes,
  IFrm,
  IFrmRes,
  INews,
  INewsRes,
  ICommunity,
  ICommunityRes,
  IPrice,
  IPriceRes,
  IMerchant,
  IMerchantRes,
  IUploadImageRes,
  ICrop,
  ICropRes,
  IApiResponse,
  ILandRes,
  IStockFactorRes,
  IOperationRes
} from '@/interfaces/master';
import * as baseAdapter from './baseAdapter';

const handleResponse = (ret: any): IApiResponse => {
  return ret?.data || { status: 'ERROR', message: 'No response data' };
};

// --- 1. Brands & Catalogs ---
export const searchBrands = async () => {
  const ret = await baseAdapter.get<IBrandRes>('/v1/brand/get-brand-list');
  return ret?.data;
};

export const addBrand = async (data: Partial<IBrand>) => {
  const ret = await baseAdapter.post<any>('/v1/brand/add-brand', data);
  return ret?.data;
};

export const updateBrand = async (data: Partial<IBrand>) => {
  const ret = await baseAdapter.put('/v1/brand/update', data);
  return ret?.data;
};

export const matchBrand = async (data: Partial<IBrand>) => {
  const ret = await baseAdapter.put('/v1/brand/match', data);
  return ret?.data;
};

// --- 2. Farmer ---
export const getFarmer = async () => {
  const ret = await baseAdapter.get<IFrmRes>('/v1/farmer/GetFarmer');
  return ret?.data;
};

export const addFarmer = async (data: Partial<IFrm>[]): Promise<IApiResponse> => {
  const ret = await baseAdapter.post<IApiResponse>('/v1/farmer/CreateFarmer', data);
  return handleResponse(ret);
};

export const updateFarmer = async (data: Partial<IFrm>[]): Promise<IApiResponse> => {
  const ret = await baseAdapter.post<IApiResponse>('/v1/farmer/UpdateFarmer', data);
  return handleResponse(ret);
};

export const deleteFarmer = async (data: Partial<IFrm>[]): Promise<IApiResponse> => {
  const ret = await baseAdapter.post<IApiResponse>('/v1/farmer/DeleteFarmer', data);
  return handleResponse(ret);
};

// --- 3. Land & Farm ---
export const getLand = async () => {
  const ret = await baseAdapter.get<ILandRes>('/v1/land/GetLand');
  return ret?.data;
};

export const addLand = async (data: Partial<IFrm>[]): Promise<IApiResponse> => {
  const ret = await baseAdapter.post<IApiResponse>('/v1/land/CreateLand', data);
  return handleResponse(ret);
};

export const updateLand = async (data: Partial<IFrm>[]): Promise<IApiResponse> => {
  const ret = await baseAdapter.post<IApiResponse>('/v1/land/UpdateLand', data);
  return handleResponse(ret);
};

export const deleteLand = async (data: Partial<IFrm>[]): Promise<IApiResponse> => {
  const ret = await baseAdapter.post<IApiResponse>('/v1/land/DeleteLand', data);
  return handleResponse(ret);
};

export const getFarm = async () => {
  const ret = await baseAdapter.get<IFrmRes>('/v1/land/GetFarm');
  return ret?.data;
};

export const addFarm = async (data: Partial<IFrm>[]): Promise<IApiResponse> => {
  const ret = await baseAdapter.post<IApiResponse>('/v1/land/CreateFarm', data);
  return handleResponse(ret);
};

export const updateFarm = async (data: Partial<IFrm>[]): Promise<IApiResponse> => {
  const ret = await baseAdapter.post<IApiResponse>('/v1/land/UpdateFarm', data);
  return handleResponse(ret);
};

export const deleteFarm = async (data: Partial<IFrm>[]): Promise<IApiResponse> => {
  const ret = await baseAdapter.post<IApiResponse>('/v1/land/DeleteFarm', data);
  return handleResponse(ret);
};

// --- 4. Crop ---
export const getCrop = async () => {
  const ret = await baseAdapter.get<ICropRes>('/v1/crop/GetCrop');
  return ret?.data;
};

export const addCrop = async (data: Partial<ICrop>[]): Promise<IApiResponse> => {
  const ret = await baseAdapter.post<IApiResponse>('/v1/crop/CreateCrop', data);
  return handleResponse(ret);
};

export const updateCrop = async (data: Partial<ICrop>[]): Promise<IApiResponse> => {
  const ret = await baseAdapter.post<IApiResponse>('/v1/crop/UpdateCrop', data);
  return handleResponse(ret);
};

export const updateCropFruitBloom = async (data: Partial<ICrop>[]): Promise<IApiResponse> => {
  const ret = await baseAdapter.post<IApiResponse>('/v1/crop/UpdateCropFruitBloom', data);
  return handleResponse(ret);
};

export const updateCropCost = async (data: Partial<ICrop>[]): Promise<IApiResponse> => {
  const ret = await baseAdapter.post<IApiResponse>('/v1/crop/UpdateCropCost', data);
  return handleResponse(ret);
};

export const updateCropYield = async (data: Partial<ICrop>[]): Promise<IApiResponse> => {
  const ret = await baseAdapter.post<IApiResponse>('/v1/crop/UpdateCropYield', data);
  return handleResponse(ret);
};

export const deleteCrop = async (data: Partial<ICrop>[]): Promise<IApiResponse> => {
  const ret = await baseAdapter.post<IApiResponse>('/v1/crop/DeleteCrop', data);
  return handleResponse(ret);
};

// --- 5. Community (UPDATED TO FULL ARRAY) ---
export const getCommunity = async () => {
  const ret = await baseAdapter.get<ICommunityRes>('/v1/community/GetCommunity');
  return ret?.data;
};

export const addCommunity = async (data: Partial<ICommunity>[]): Promise<IApiResponse> => {
  const ret = await baseAdapter.post<IApiResponse>('/v1/community/CreateCommunity', data);
  return handleResponse(ret);
};

export const updateCommunity = async (data: Partial<ICommunity>[]): Promise<IApiResponse> => {
  const ret = await baseAdapter.post<IApiResponse>('/v1/community/UpdateCommunity', data);
  return handleResponse(ret);
};

export const deleteCommunity = async (data: Partial<ICommunity>[]): Promise<IApiResponse> => {
  const ret = await baseAdapter.post<IApiResponse>('/v1/community/DeleteCommunity', data);
  return handleResponse(ret);
};

// --- 6. News (UPDATED TO FULL ARRAY) ---
export const getNews = async () => {
  const ret = await baseAdapter.get<INewsRes>('/v1/news/GetNews');
  return ret?.data;
};

export const addNews = async (data: Partial<INews>[]): Promise<IApiResponse> => {
  const ret = await baseAdapter.post<IApiResponse>('/v1/news/CreateNews', data);
  return handleResponse(ret);
};

export const updateNews = async (data: Partial<INews>[]): Promise<IApiResponse> => {
  const ret = await baseAdapter.post<IApiResponse>('/v1/news/UpdateNews', data);
  return handleResponse(ret);
};

export const deleteNews = async (data: Partial<INews>[]): Promise<IApiResponse> => {
  const ret = await baseAdapter.post<IApiResponse>('/v1/news/DeleteNews', data);
  return handleResponse(ret);
};

// --- 7. Merchant (UPDATED TO FULL ARRAY) ---
export const getMerchant = async () => {
  const ret = await baseAdapter.get<IMerchantRes>('/v1/merchant/GetMerchants');
  return ret?.data;
};

export const addMerchant = async (data: Partial<IMerchant>[]): Promise<IApiResponse> => {
  const ret = await baseAdapter.post<IApiResponse>('/v1/merchant/CreateMerchant', data);
  return handleResponse(ret);
};

export const updateMerchant = async (data: Partial<IMerchant>[]): Promise<IApiResponse> => {
  const ret = await baseAdapter.post<IApiResponse>('/v1/merchant/UpdateMerchant', data);
  return handleResponse(ret);
};

export const deleteMerchant = async (data: Partial<IMerchant>[]): Promise<IApiResponse> => {
  const ret = await baseAdapter.post<IApiResponse>('/v1/merchant/DeleteMerchant', data);
  return handleResponse(ret);
};

// --- 8. Price (UPDATED TO FULL ARRAY) ---
export const getPrice = async () => {
  const ret = await baseAdapter.get<IPriceRes>('/v1/price/GetPrice');
  return ret?.data;
};

export const addPrice = async (data: Partial<IPrice>[]): Promise<IApiResponse> => {
  const ret = await baseAdapter.post<IApiResponse>('/v1/price/CreatePrice', data);
  return handleResponse(ret);
};

export const updatePrice = async (data: Partial<IPrice>[]): Promise<IApiResponse> => {
  const ret = await baseAdapter.post<IApiResponse>('/v1/price/UpdateAveragePrice', data);
  return handleResponse(ret);
};

export const deletePrice = async (data: Partial<IPrice>[]): Promise<IApiResponse> => {
  const ret = await baseAdapter.post<IApiResponse>('/v1/price/DeletePrice', data);
  return handleResponse(ret);
};

// --- 9. Images & Catalogs ---
export const getImages = async () => {
  const ret = await baseAdapter.get<IUploadImageRes>('/v1/image/GetImage');
  return ret?.data;
};

export const uploadCommunityImage = async (data: any[]) => {
  const ret = await baseAdapter.post<any>('/v1/community/UploadCommunityImage', data);
  return ret?.data;
};

export const uploadFarmerImage = async (data: any[]) => {
  const ret = await baseAdapter.post('/v1/farmer/UploadFarmerImage', data);
  return ret?.data;
};

export const uploadOperationImage = async (data: any[]) => {
  const ret = await baseAdapter.post('/v1/image/UploadImages', data);
  return ret?.data;
};

export const uploadGapImage = async (data: any[]) => {
  const ret = await baseAdapter.post('/v1/image/UploadGAPImages', data);
  return ret?.data;
};

export const searchCatalogs = async () => {
  const ret = await baseAdapter.get<ICatalogRes>('/v1/catalog/gets');
  return ret?.data;
};

export const addCatalog = async (data: Partial<ICatalog>) => {
  const ret = await baseAdapter.post<any>('/v1/catalog/add', data);
  return ret?.data;
};

export const updateCatalog = async (data: Partial<ICatalog>) => {
  const ret = await baseAdapter.put('/v1/catalog/update', data);
  return ret?.data;
};

export const matchCatalog = async (data: Partial<ICatalog>) => {
  const ret = await baseAdapter.put('/v1/catalog/match', data);
  return ret?.data;
};
// --- 10. StockFactor ---
export const getStockFactor = async () => {
  const ret = await baseAdapter.get<IStockFactorRes>('/v1/stock/getStock');
  return ret?.data;
};

export const actionStock = async (
  category: 'Fertilizer' | 'Chemical' | 'Equipment',
  action: 'Create' | 'Update' | 'Delete',
  data: any[]
): Promise<IApiResponse> => {
  // Postman URL requirement: Action + Category + "Stock"
  const endpoint = `/v1/stock/${action}${category}Stock`;
  const ret = await baseAdapter.post<IApiResponse>(endpoint, data);
  return ret?.data || { status: 'ERROR', message: 'No response data' };
};

// --- 11. Operation ---
export const getOperation = async () => {
  const ret = await baseAdapter.get<IOperationRes>('/v1/operation/getOperation');
  return ret?.data;
};

export const actionOperation = async (
  category: 'Watering' | 'Fertilizing' | 'Chemical' | 'Harvest' | 'PestControl' | 'Survey',
  action: 'Create' | 'Update' | 'Delete',
  data: any[]
): Promise<IApiResponse> => {
  // Postman URL requirement: Action + "Operation"
  const endpoint = `/v1/operation/${action}${category}Operation`;
  const ret = await baseAdapter.post<IApiResponse>(endpoint, data);
  return ret?.data || { status: 'ERROR', message: 'No response data' };
}

export const synctoERP = async (data: { MASTER_TYPE: 'BRAND' | 'CATALOG' | 'PRODUCT' }) => {
  const ret = await baseAdapter.post('/v1/master/sync', data);
  return ret?.data;
};